import { clone } from '@jack-henry/frontend-utils/functions';
import { AccountReconProductFeatureModelDto } from '@treasury/api/bo';
import { AccountProductConfiguration } from '../../../account/entities/account-product-configuration.entity';
import { CompanyProductFeature } from './company-product-feature.entity';

const defaultDto: AccountReconProductFeatureModelDto = {
    id: 0,
    type: 'AccountRecon',
    productUniqueId: '',
    isConfigurable: true,
    companyId: 0,
};
export class AccountReconProductFeature extends CompanyProductFeature<AccountReconProductFeatureModelDto> {
    constructor(dto: AccountReconProductFeatureModelDto = clone(defaultDto)) {
        super(dto);
    }

    public get id() {
        return this.dto.id;
    }

    public set id(value: number) {
        this.dto.id = value;
    }

    public get companyId(): number {
        return this.dto.companyId;
    }

    public set companyId(value: number) {
        this.dto.companyId = value;
    }

    public get accounts(): AccountProductConfiguration[] {
        return (
            this.dto.accounts
                ?.filter(account => account.isEnabled)
                .map(account => new AccountProductConfiguration(account)) ?? []
        );
    }

    public set accounts(value: AccountProductConfiguration[]) {
        this.dto.accounts = value.map(account => account.toDto());
    }

    public get accountIds(): number[] {
        return this.accounts.map(account => account.accountId);
    }

    public set accountIds(value: number[]) {
        this.dto.accounts = this.dto.accounts?.map(account => {
            account.isEnabled = value.includes(account.accountId);
            return account;
        });
    }
}
